import { Form, Tooltip, InputNumber, Select, } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const WavelengthField = ({ name, disabled }) => {
    const [customWavelengthMin, setCustomWavelengthMin] = useState(180)
    const [customWavelengthMax, setCustomWavelengthMax] = useState(1000000000000000)
    const [customWavelengthPlaceholder, setCustomWavelengthPlaceholder] = useState('180nm to 1,000,000m')
    const { t } = useTranslation()
    return (
        <>
            <Tooltip
                mouseEnterDelay={0.5}
                title={'The wavelength of the laser.'}
                placement='left'
                destroyTooltipOnHide
            >
                <Form.Item
                    label= {t('10076')/** Wavelength */}
                    name={[...name, 'num']}
                    rules={[{ required: true, message: 'Please specify value.' }]}
                >
                    <InputNumber
                        disabled={disabled}
                        tabIndex={1}
                        min={customWavelengthMin}
                        max={customWavelengthMax}
                        placeholder={customWavelengthPlaceholder}
                        style={{ width: '100%' }}
                        addonAfter={
                            <Form.Item noStyle shouldUpdate>
                                {({ setFieldValue }) => (
                                    <Form.Item
                                        noStyle
                                        name={[...name, 'unit']}
                                        rules={[{ required: true, message: 'Please specify unit.' }]}
                                    >
                                        <Select
                                            disabled={disabled}
                                            tabIndex={-1}
                                            onChange={(e) => {
                                                // console.log(`pandesal`, e)
                                                if (e) {

                                                    if (e === 'n') {
                                                        setFieldValue([...name, 'num'])
                                                        setCustomWavelengthMin(180)
                                                        setCustomWavelengthMax(1000000000000000)
                                                        setCustomWavelengthPlaceholder('180nm to 1,000,000')
                                                    } else if (e === 'u') {
                                                        setFieldValue([...name, 'num'])
                                                        setCustomWavelengthMin(180 / 1000)
                                                        setCustomWavelengthMax(1000000000000000 / 1000)
                                                        setCustomWavelengthPlaceholder('0.18µm to 1,000,000m')
                                                    }
                                                }
                                            }}
                                            style={{ width: 80 }}
                                            options={[
                                                { value: 'n', label: 'nm' },
                                                { value: 'u', label: 'µm' }
                                            ]}
                                        />
                                    </Form.Item>
                                )}

                            </Form.Item>
                        }
                    />
                </Form.Item>

            </Tooltip>
        </>
    )
}

export default WavelengthField